export default __webpack_public_path__ + "static/media/profilepic.0a0e2999.jfif";